import {$http, Constants} from '@/store/actions/constants';

const url = `${Constants.BaseURL}/announcement`;
export const AnnouncementAction = {
    Find: ({commit, state}, search) => {
        return $http.get(url, {...state.authHeader, params: search}).then(r => {
            if (r.status === 200) {
                let announcements = r.data.map(element => {
                    const ca = Constants.formatFromDate(element.created_at);
                    const ea = Constants.formatFromDate(element.expires_at);
                    return {
                        ...element,
                        created_at: ca ? ca : '',
                        expires_at: ea ? ea : '',
                    };
                });
                commit('SET_ANNOUNCEMENTS', announcements);
            }
        });
    },

    Delete: ({commit, state}, id) => {
        return $http.delete(`${url}/${id}`, state.authHeader).then(res => {
            if (res.status === 200) {
                commit('DELETE_ANNOUNCEMENT', id);
            }
        });
    },

    Edit: ({commit, state}, payload) => {
        return $http.put(`${url}/${payload.id}`, payload.data, state.authHeader);
    },

    Get: ({_, state}, id) => {
        return $http.get(`${url}/${id}`, state.authHeader);
    },

    Add: ({commit, state}, data) => {
        return $http.post(url, data, state.authHeader);
    },
};